import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  directoryApi,
  type ProvisionAppRequest,
  type ProvisionAppResponse,
} from '../client';
import { useSupportAccounts } from './useSupportAccounts';

/**
 * Enable an app for the account the support session currently points at.
 *
 * <p>
 * Invalidates the support-account list on success, because the subscription
 * set it reports is exactly what just changed — without that, the account
 * still reads as unsubscribed until the tab is reloaded.
 * </p>
 */
export function useProvisionApp() {
  const queryClient = useQueryClient();

  return useMutation<ProvisionAppResponse, Error, ProvisionAppRequest>({
    mutationFn: (body) => directoryApi.provisionApp(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: useSupportAccounts.queryKey });
    },
  });
}
